import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { ContainerContext } from '../../../../../common/container/ContainerContext';
import { observer } from 'mobx-react';
import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { IUserPageProperties } from '../../IUserPageProperties';
import { ApplicationInfoContent } from './parts/ApplicationInfoContent';
import { ApplicationDetailDomain } from './store/ApplicationDetailDomain';
import { ApplicationDetailsMode } from './store/ApplicationDetailsMode';

export interface IApplicationInfoProperties extends IUserPageProperties {}

export const ApplicationInfo = observer(({ layoutDomain }: IApplicationInfoProperties) => {
  const container = useContext(ContainerContext);
  const classes = useStyles();
  const [domain] = useState(new (container.get(ApplicationDetailDomain))(layoutDomain));
  const { applicationId } = useParams<any>();

  useEffect(() => {
    domain.startPage(container, ApplicationDetailsMode.view, applicationId);
  }, [domain, applicationId, container]);

  return (
    <Grid container direction="row" justifyContent="center" alignItems="flex-start" className={classes.pageContainer}>
      <Grid item xs={12} className={classes.contentContainer}>
        <ApplicationInfoContent domain={domain} />
      </Grid>
    </Grid>
  );
});

const useStyles = makeStyles(() => ({
  pageContainer: {
    height: '100%',
    overflow: 'hidden',
    minHeight: 0,
  },
  contentContainer: {
    height: '100%',
    overflow: 'hidden',
    minHeight: 0,
  },
}));
